import { Component, Input } from '@angular/core';

@Component({
  selector: 'document-company-name-renderer',
  template: `
    <span>
      {{ getCompanyName(rowData?.CompanyId) }}
    </span>
  `,
  standalone: true,
})
export class RenderCompanyName {
  @Input() rowData: any;

  getCompanyName(num: string) {
    switch (Number.parseInt(num)) {
      case -1:
        return 'All';
      case 0:
        return 'GEA York ';
      case 1:
        return 'GEA Vancouver';
      case 2:
        return 'GEA Vancouver (Aerofreeze)';
      case 3:
        return 'GEA France';
      case 4:
        return 'GEA Berlin';
      case 5:
        return "GEA 's-Hertogenbosch";
      case 6:
        return 'Bock';
      case 7:
        return 'GEA Suzhou';
      case 8:
        return 'GEA EMEA Skids';
      case 9:
        return 'GEA Cape Town';
      case 10:
        return 'GEA EMEA Skids (Service Sales)';
      case 11:
        return "GEA 's-Hertogenbosch (Service Sales)";
      default:
        return 'None';
    }
  }
}
